import { fileUploadColumn, grandTotalFields, totalsColumn, unitInputColumn, valueInputColumn } from './columns'

// --- Electricity Purchased Columns ---
export const electricityPurchasedColumns = [
    {
        label: 'Supplier',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Eskom' },
            { id: 1, value: 'Municipal' }
        ],
        selectLabel: 'Select Supplier'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'kWh' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
];

// --- Electricity Purchased Totals ---
export const electricityPurchasedTotalColumns = totalsColumn.kilowatts
export const electricityPurchasedGrandTotalFields = grandTotalFields.kilowatts


// --- Renewable Energy Produced Columns ---
export const renewableEnergyProducedColumns = [
    {
        label: 'Asset',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Solar' },
            { id: 1, value: 'Biogas' },
            { id: 2, value: 'Wind' }
        ],
        selectLabel: 'Select type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'kWh' }
        ],
    },
    valueInputColumn,
    fileUploadColumn
];

// --- Renewable Energy Produced Totals ---
export const renewableEnergyPurchasedTotalsColumn = [
    { label: 'Month', field: 'month' },
    { label: 'Wind (kWh)', field: 'wind' },
    { label: 'Solar (kWh)', field: 'solar' },
    { label: 'Biogas (kWh)', field: 'biogas' },
    { label: 'Total kWh', field: 'total' }
];

export const renewableEnergyPurchasedGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Wind (kWh)', field: 'grand_total_wind' },
    { label: 'Grand Total Solar (kWh)', field: 'grand_total_solar' },
    { label: 'Grand Total Biogas (kWh)', field: 'grand_total_biogas' },
    { label: 'Grand Total kWh', field: 'grand_total' }
];